import Vue from 'vue';
import Vuex from 'vuex'

import helper from './utils/helper'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
      pageTitle:'页面标题',
      authInfo:{
        account:{}
      },
      assetUrl: process.env.VUE_APP_ASSET_URL+'/',
      loginVisible:false,
      loginStep:1,
      menus:[],
    },
    mutations: {
      setAuthInfo(state, info){
        state.authInfo = info;
      },
      setPageTitle(state, title){
        state.pageTitle = title;
      },
      setAccount(state,account){
        state.authInfo = {...state.authInfo, account:account};
      },
      initMenu(state,menus){
        state.menus = menus;
      },
      showLoginModal(state,step){
        state.loginVisible = true;
        state.loginStep = step;
      },
      hideLoginModal(state){
        state.loginVisible = false;
        
      }
    },
    actions: {
      initAuthInfo(context){
        let info = helper.getStorage('union-auth-info');

        if(!info){
          info = {
            account:{}
          };
        }else{
          info.account = info.account || {};
        }
        context.commit('setAuthInfo', info);

        let menus = [
          {
            label:'统计面板',
            icon:'pie-chart',
            route:'/'
          },
          {
            label:'我要推广',
            icon:'share-alt',
            route:'/products'
          },
          {
            label:'定制优惠',
            icon:'highlight',
            route:'/diyPromote'
          },
          {
            label:'数据中心',
            icon:'database',
            route:'/database'
          },
          {
            label:'佣金结算',
            icon:'transaction',
            route:'/commission'
          },
          {
            label:'页面嵌入广告',
            icon:'picture',
            route:'/jsAdverts'
          }
        ]
       
        if(info.parent_uid > 0){
          menus.push({
            label:'我的顾问',
            icon:'user',
            route:'/consultant'
          });
        }
  
        context.commit('initMenu', menus);
      }
    }
  })

  export default store;